import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTrash } from 'react-icons/fa';

import { Card, Link, HStack as Grid, Typography, Box } from '@tq/ui-components';
import { FileIcon } from '@tq/ui-components/dist/components/forms-engine/components/FileUpload/components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { tqc } from '@tq/ui-components/dist/system';

import { formatBytes } from 'tools';
import { UploadedFile } from 'types';
import { useFormatLocaleDate, StandardDateFormats } from 'config';

export interface FilePreviewProps {
  uploadedFile: UploadedFile;
  onRemoveFile?: (uploadedFile: UploadedFile) => void;
}
export const FilePreview: React.FC<FilePreviewProps> = ({ uploadedFile, onRemoveFile }) => {
  const { t } = useTranslation('file_preview');
  const formatLocaleDate = useFormatLocaleDate();

  return (
    <Card
      p={6}
      my={5}
      display={{ base: 'grid', md: 'flex' }}
      alignContent='center'
      gridGap={{ base: 6, md: 0 }}
      justifyContent='space-between'
    >
      <Box display={{ base: 'grid', md: 'flex' }} gridGap={2}>
        <strong>{t('document', 'Document')}:</strong>
        <tqc.span display='flex' alignItems='center'>
          <Typography fontSize='1.2rem' mr={2}>
            <FileIcon fileType={uploadedFile.file.type} />
          </Typography>
          <tqc.span>{uploadedFile.file.name}</tqc.span>
        </tqc.span>
      </Box>
      <Grid gridGap={2}>
        <strong>{t('size', 'Size')}:</strong>
        <Typography>{formatBytes(uploadedFile.file.size)}</Typography>
      </Grid>
      <Grid gridGap={2}>
        <strong>{t('uploaded', 'Uploaded')}:</strong>
        <Typography>
          {formatLocaleDate(uploadedFile.uploadedDate, StandardDateFormats.dateAndTime)}
        </Typography>
      </Grid>
      <Grid
        gridGap={{ base: 0, lg: 10 }}
        onClick={() => onRemoveFile?.(uploadedFile)}
        sx={{ cursor: 'pointer' }}
      >
        <Link>{t('remove', 'Remove')}</Link>
        <FaTrash color={COLOURS.blue[400]} />
      </Grid>
    </Card>
  );
};
